// 资源预加载和按需加载工具类
class ResourceLoader {
  constructor() {
    this.preloaded = new Set()
    this.loading = new Set()
    this.queue = []
  }

  // 预加载图片
  preloadImage(url) {
    return new Promise((resolve, reject) => {
      if (this.preloaded.has(url)) {
        resolve(url)
        return
      }

      if (this.loading.has(url)) {
        // 如果正在加载，加入队列
        this.queue.push({ url, resolve, reject })
        return
      }

      this.loading.add(url)
      const img = new Image()
      img.crossOrigin = 'anonymous'
      img.onload = () => {
        this.preloaded.add(url)
        this.loading.delete(url)
        resolve(url)
        // 处理队列中的相同请求
        this.processQueue(url)
      }
      img.onerror = (error) => {
        this.loading.delete(url)
        reject(error)
        // 处理队列中的相同请求
        this.processQueue(url, error)
      }
      img.src = url
    })
  }

  // 批量预加载图片
  async preloadImages(urls) {
    const promises = urls.map(url => this.preloadImage(url))
    return Promise.all(promises)
  }

  // 处理队列中的请求
  processQueue(url, error = null) {
    const pending = this.queue.filter(item => item.url === url)
    this.queue = this.queue.filter(item => item.url !== url)
    
    pending.forEach(item => {
      if (error) {
        item.reject(error)
      } else {
        item.resolve(url)
      }
    })
  }

  // 检查资源是否已预加载
  isPreloaded(url) {
    return this.preloaded.has(url)
  }

  // 按需加载资源
  async loadOnDemand(url) {
    if (this.isPreloaded(url)) {
      return url
    }
    return this.preloadImage(url)
  }
}

// 导出单例
const resourceLoader = new ResourceLoader()
export default resourceLoader